import { useTrackingEvent } from "./useTrackingEvent";
export const useTrackingLinkClick = ({ data, event, }) => {
    const EVENT_DATA = Object.assign(Object.assign({}, data), { event });
    return useTrackingEvent(EVENT_DATA);
};
